import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const PartnerAccountsService = {
  async getPartnerAccounts(page, perPage) {
    const params = generateQueryParams({ page, size: perPage });

    const res = await axios.get('payments/v1/partnerAccounts/', { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getNewPartnerAccounts() {
    const res = await axios.post('payments/v1/partnerAccounts/');

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async editPartnerAccounts(data, id) {
    const res = await axios.put(`payments/v1/partnerAccounts/${id}/`, data);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async deletePartnerAccounts(id) {
    const res = await axios.delete(`payments/v1/partnerAccounts/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
